import * as M from "@discovery/prelude/lib/data/maybe";
import { pushLinkToAppEvent } from "@discovery/common-dplus/lib/adobe";
import { BRANCH_KEY_DEV, BRANCH_KEY_PROD, } from "@discovery/common-dplus/lib/env";
import { Icons, Icon } from "../../../components/atoms/icon";
import * as styles from "./styles.css";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _user } from "@discovery/common-dplus/lib/state";
import Strings from "../../../utils/hardcoded.json";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import { copyToClipboard } from "../../../utils/share";
import * as Bowser from "bowser";
const bowser = Bowser.getParser(window.navigator.userAgent);
export const Share = ({ route, setToastMsg, title, image, descriptionM, type, }) => {
    const [userM] = useGlobalState(_user);
    const userDetails = {
        idM: M.map((user) => user.id, userM),
        anonymousM: M.map((user) => user.attributes.anonymous, userM),
        packagesM: M.chain((user) => user.attributes.packages, userM),
    };
    const userPackage = M.fromMaybe(userDetails.packagesM, [""]);
    const userType = userPackage[0];
    const isAnonymous = M.fromMaybe(userDetails.anonymousM, false);
    const userId = M.fromMaybe(userDetails.idM, "");
    const shareHandler = (mediaType) => {
        const name = title && `Watch ${`'`}${title}${`'`} now on discovery+`;
        if (window.location.hostname === "www.discoveryplus.in") {
            branch && branch.init(BRANCH_KEY_PROD);
        }
        else {
            branch && branch.init(BRANCH_KEY_DEV);
        }
        const desktopUrl = config.shareBaseURL +
            route +
            `?type=${type === "clip" ? "CLIP" : "EPISODE"}`;
        const linkUrl = config.shareBaseURL + route;
        const linkData = {
            data: {
                $desktop_url: desktopUrl,
                $canonical_identifier: linkUrl,
                $og_title: title,
                $og_description: descriptionM && M.fromMaybe(descriptionM, ""),
                $og_image_url: `${image && image.src}?w=1080`,
                $twitter_image_url: `${image && image.src}?w=1080`,
                $og_image_width: "1080",
                $og_image_height: "200",
                $twitter_title: title,
                twitter_description: descriptionM && M.fromMaybe(descriptionM, ""),
                $canonical_url: linkUrl,
                $deeplink_path: linkUrl,
            },
        };
        branch.link(linkData, (err, link) => {
            console.warn(err);
            if (mediaType === "twitter") {
                window.open(`http://www.twitter.com/share?url=${link}&text=${name}`, "_blank");
            }
            else if (mediaType === "fb") {
                window.open(`https://www.facebook.com/sharer/sharer.php?u=${link}&t=${name}`, "_blank");
            }
            else {
                copyLink(link);
            }
        });
    };
    const copyLink = (value) => {
        if (value) {
            const isSafari = bowser.getBrowser().name === "Safari";
            if (isSafari) {
                copyToClipboard(value);
            }
            else {
                const tempInput = document.createElement("input");
                tempInput.value = value;
                document.body.appendChild(tempInput);
                tempInput.select();
                document.execCommand("copy");
                tempInput && document.body.removeChild(tempInput);
                tempInput && setToastMsg && setToastMsg(Strings.LINK_COPIED, true);
            }
        }
    };
    return (React.createElement("div", { className: styles.overlay },
        React.createElement("div", { onClick: () => {
                pushLinkToAppEvent("social share", "facebook", "facebook", isAnonymous, userType, userId);
                shareHandler("fb");
            }, id: "#facebook" },
            React.createElement(Icon, { type: Icons.FaceBookShareIcon, className: styles.imageStyle })),
        React.createElement("div", { onClick: () => {
                pushLinkToAppEvent("social share", "twitter", "twitter", isAnonymous, userType, userId);
                shareHandler("twitter");
            }, id: "#twitter" },
            React.createElement(Icon, { type: Icons.Twitter, className: styles.imageStyle })),
        React.createElement("div", { onClick: () => shareHandler(), className: styles.copyLink, id: "#clipboard" },
            React.createElement(Icon, { type: Icons.CopyLink, className: styles.imageStyle }))));
};

